<template>
    <span class="border-b p-0 self-center w-2/3"></span>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
span {
    height: 0 !important;
}
</style>
